import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import './v-time-picker.component.scss';

@Component({
    selector: 'v-time-picker',
    template: require('./v-time-picker.component.html')
})
export class VTimePickerComponent implements OnChanges {

    @Input() selectedTime: string;
    @Output() selectedTimeChange = new EventEmitter<string>();

    @Input() increments: 5 | 10 | 15 | 20 | 30 = 15;
    @Input() disabled: boolean;

    @Input() label: string;

    //--

    availableTimes: string[];

    constructor() { }

    ngOnChanges(): void {
        this.setupAvailableTimes()

        if (this.selectedTime) {            
            this.timeChanged(this.selectedTime);            
        }    
    }

    timeChanged(time: string): void {
        this.selectedTime = time;
        this.selectedTimeChange.emit(time);
    }

    // --

    private setupAvailableTimes(): void {
        this.availableTimes = [];

        const incrementsPerHour = 60 / this.increments;

        for (let hour = 0; hour < 24; hour++) {
            for (let inc = 0; inc < incrementsPerHour; inc++) {
                const hourString = String(hour).length == 2 ? String(hour) : "0" + String(hour);
                let minutes = this.increments * inc;

                const minuteString = String(minutes).length == 2 ? String(minutes) : "0" + String(minutes);

                const timeString = `${hourString}:${minuteString}`;
                this.availableTimes.push(timeString);
            }
        }
    }

}
